import React, { useState } from "react";
import ConvertSequence from "./ConvertSequence";
import ConvertSequenceFasta from "./ConvertSequenceFasta";
import TabularFormConversion from "./TabularFormConversion"
import ThreeLetterCodeConversion from "./ThreeLetterCodeConversion";
import St25CodeConversionToFasta from "./St25CodeConversionToFasta";
import TranslationTool from "./TranslationTool";
import {useSelector} from "react-redux";

function ConvertSequenceFormat(){

    //const Tabs = ["ST.26", "FASTA", "Tabular", "EMBL", "ST.25", "Three Letter Code", "Single Letter Code", "Clustal Omega"]
    const [state, setState] = useState("ST.26");
    const userInfo = useSelector(state => state.setUserInfo);

    function switchPage(pageName){
        setState(pageName);
    }

    return(
        <div>
            {userInfo.current_user.user_class_id != 12 &&
            <span> 
            <div style= {{ marginTop: '-33px', marginLeft: '-5px' }}>
                <button className={state === "ST.26" ? "inactiveTab" : "accountTabs"} onClick={()=>switchPage("ST.26")}> ST.26</button>
                <button className={state === "FASTA" ? "inactiveTab" : "accountTabs"} onClick={()=>switchPage("FASTA")}>FASTA</button>
                <button className={state === "Tabular" ? "inactiveTab" : "accountTabs"} onClick={()=>switchPage("Tabular")}>Tabular</button>
                <button className={state === "ST.25" ? "inactiveTab" : "accountTabs"} onClick={()=>switchPage("ST.25")}>ST.25</button>
                <button className={state === "Three Letter Code" ? "inactiveTab" : "accountTabs"} onClick={()=>switchPage("Three Letter Code")}>Three Letter Code</button>
                <button className={state === "Translation Tool" ? "inactiveTab" : "accountTabs"} onClick={()=>switchPage("Translation Tool")}>Translation Tool</button>
            </div>

            {state === "ST.26" &&
            <div>
                <ConvertSequence></ConvertSequence>
            </div>
            }
            {state === "FASTA" &&
            <div>
                <ConvertSequenceFasta></ConvertSequenceFasta>
            </div>
            }
            {state === "Tabular" &&
            <div>
                 <TabularFormConversion></TabularFormConversion>
            </div>
            }
            {state === "ST.25" &&
            <div>
                <St25CodeConversionToFasta></St25CodeConversionToFasta>
            </div>
            }
            {state === "Three Letter Code" &&
            <div>
                <ThreeLetterCodeConversion></ThreeLetterCodeConversion>
            </div>
            }
            {state === "Translation Tool" &&
            <div>
                <TranslationTool></TranslationTool>
            </div>
            }
            </span>}
        </div>
    );

}

export default ConvertSequenceFormat;
